import React, { useState, useEffect } from 'react';
import './App.css';
import LowPolyBackground from './components/Background/LowPolyBackground';
import LoginForm from './components/Auth/LoginForm';
import RegisterForm from './components/Auth/RegisterForm';
import ServerView from './components/Main/ServerView';
import { authService } from './services/authService';
import { pushService } from './services/pushService';
import PublicView from './components/Public/PublicView';

function App() {
  const [currentView, setCurrentView] = useState('login');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // ✅ Проверяем авторизацию СРАЗУ
  const isAuthenticated = authService.isAuthenticated();

  // ✅ Публичный маршрут только для НЕавторизованных
  const path = decodeURIComponent(window.location.pathname);
  const isPublicRoute =
      !isAuthenticated &&                     // ← ключевое условие
      path !== '/' &&
      !path.startsWith('/api') &&
      !path.startsWith('/login') &&
      !path.startsWith('/register') &&
      !path.startsWith('/static') &&
      !path.startsWith('/favicon');
  
  useEffect(() => {
    if (isPublicRoute) {
      setLoading(false);
      return;
    }
    const initPush = async () => {
      if(authService.isAuthenticated())
      {
      try {
        const publicKey = 'BB2bRApvXZoILHnJGJPC6qi2_izVDHo3e2Go7FLsbhMrT7g8RgI9uTrDWU3RhZ9I_fasZAGc38sTDMNPOTR8c88';
        await pushService.registerSW();
        const subscription = await pushService.subscribe(publicKey);
        await pushService.sendSubscriptionToBackend(subscription, authService);
        //console.log('✅ Push-подписка сохранена');
      } catch (error) {
        console.error('❌ Ошибка Push:', error);
      }
    }
    };
    initPush();
  },[isPublicRoute]);

  useEffect(() => {
    if (isPublicRoute) return;
    const checkAuth = async () => {
      //console.log('Checking auth...');
      //console.log('Token exists:', !!localStorage.getItem('videochat_token'));
      
      if (authService.isAuthenticated()) {
        //console.log('Token found, fetching user...');
        try {
          const userData = await authService.getCurrentUser();
          //console.log('User restored:', userData);
          setUser(userData);
          setCurrentView('main');
        } catch (error) {
          console.error('Auth check failed:', error);
          // Токен невалидный - удаляем его
          //localStorage.removeItem('videochat_token');
          //localStorage.removeItem('refresh_token');
          setCurrentView('login');
        }
      } else {
        //console.log('No token found');
        setCurrentView('login');
      }
      setLoading(false);
    };
    
    checkAuth();
  }, [isPublicRoute]);

  if (isPublicRoute) {
    return <PublicView publicUrl={path} />;
  }

  const handleLogin = (userData) => {
    setUser(userData);
    setCurrentView('main');
  };

  const handleRegister = (userData) => {
    setUser(userData);
    setCurrentView('main');
  };

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken) {
      try {
        await authService.logout(refreshToken);
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
    
    setUser(null);
    setCurrentView('login');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#2f3136]">
        <div className="text-white text-xl">Загрузка...</div>
      </div>
    );
  }
  // 1. Публичный маршрут: /МечтаТут, /Работа и т.д.
  
  return (
    <LowPolyBackground>
      <div className="w-full h-full relative">
        {currentView === 'login' && (
          <LoginForm 
            onLogin={handleLogin} 
            onSwitchToRegister={() => setCurrentView('register')} 
          />
        )}
        
        {currentView === 'register' && (
          <RegisterForm 
            onRegister={handleRegister} 
            onSwitchToLogin={() => setCurrentView('login')} 
          />
        )}
        
        {currentView === 'main' && user && (
          <ServerView 
            user={user} 
            onLogout={handleLogout} 
          />
        )}
      </div>
    </LowPolyBackground>
  );
}

export default App;